import { render } from "./PaymentComp.vue?vue&type=template&id=25d3fb16"
import script from "./PaymentComp.vue?vue&type=script&lang=js"
export * from "./PaymentComp.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__